// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_hZe","cls2":"shared-cls2_eec shared-cls1_hZe"};